import AppContext from '@/types/context'
import { AreaItem } from '@/types/cms/AreaItem'
import Partials from '@/elements/Partials'
import React from 'react'
import { clsx } from 'clsx'
import styles from './GridHighlight.module.scss'

const GridHighlight = ({
  item,
  context,
  children,
}: {
  item: AreaItem
  context: AppContext
  children?: React.ReactNode
}) => {
  return (
    <div
      className={clsx(styles.container, styles[`container--${item.model?.fields?.backgroundColor}`])}
      data-cy={`grid-highlight-${item.model?.fields?.backgroundColor}`}
    >
      {item.children.map((child, index) => {
        return <Partials key={index} context={context} item={child as any} />
      })}
      {children && children}
    </div>
  )
}

export default GridHighlight
